import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AnalyticsDashboard from './analyticsDashboard/AnalyticsDashboard';

const AnalyticsRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<AnalyticsDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default AnalyticsRoutes;
